/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuccessConsistencyScoreResultResponse } from '../models/SuccessConsistencyScoreResultResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ConsistencyScoreControllerService {

    /**
     * Get consistency score for the authenticated user
     * Returns the consistency score details including score, status, and goals
     * @returns SuccessConsistencyScoreResultResponse Consistency score result retrieved successfully
     * @throws ApiError
     */
    public static getConsistencyScore(): CancelablePromise<SuccessConsistencyScoreResultResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/consistency-score',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `Consistency score not found (feature disabled or not applicable)`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

}
